import { AHButton, Box } from "arkh";
import React from "react";

import { WidgetScreenPreviewProps } from "./WidgetScreenPreviewProps";
import { WASizePreviewRegularScale } from "@/src/features/Storecast/Storecast/WidgetAdd/WASizePreview/WASizePreviewRegular";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { WAFakeHeader } from "@/src/features/Storecast/Storecast/WidgetAdd/WAFakeHeader";
import { WAPreviewContainer } from "@/src/features/Storecast/Storecast/WidgetAdd/WAPreviewContainer";

export function WidgetScreenPreviewRegular(props: WidgetScreenPreviewProps) {
  const intl_tokens = useIntlTokens();

  return (
    <Box style={{ flex: 1 }} color="surface-background-light">
      <WAFakeHeader title={intl_tokens.Preview} headerLeftType={null} />
      <Box style={{ flex: 1 }} space="medium">
        <Box
          space="large"
          cornerRadius="large"
          style={{
            flex: 1,
            borderWidth: 1,
          }}
          color="surface"
          borderColor="border-primary"
        >
          <Box
            style={{
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WAPreviewContainer
              h={props.size.h}
              w={props.size.w}
              unitSize={props.unitSize}
              scale={WASizePreviewRegularScale}
            >
              {props.children}
            </WAPreviewContainer>
          </Box>
          <AHButton
            disabled={props.disabled}
            themeType="primary"
            title={intl_tokens.Save}
            style={{ alignSelf: "stretch" }}
            onPress={props.onSave}
            loading={props.loading}
          />
        </Box>
      </Box>
    </Box>
  );
}
